import { REDIRECT_DETAIL } from '../../../../../routes/paths';
import { Table } from '../../../../components/general/table';
import { useRedirectPqrList } from './hook';
import { RedirectPqrListProps } from './props';

export const RedirectPqrList = ({ filters }: RedirectPqrListProps) => {
    const { columns, rows, loading, page, pageSize, paginator, total } =
        useRedirectPqrList(filters);

    return (
        <Table
            columns={columns}
            rows={rows}
            rowCount={total}
            loading={loading}
            paginationModel={{
                page,
                pageSize,
            }}
            onPaginationModelChange={paginator}
            pageSizeOptions={[2, 10, 20, 50]}
            disableRowSelectionOnClick
            onRowClick={(item, event) => {
                if (!(event.target as Element).closest('.no-click-cell')) {
                    window.open(`${REDIRECT_DETAIL}/${item.row.id}`, '_blank');
                }
            }}
            autoAdjustHeight
        />
    );
};
